module.exports = __webpack_public_path__ + "static/media/signWP.0865a6b9.png";